import { Color } from '@tiptap/extension-color';
import Link from '@tiptap/extension-link';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import type { Editor } from '@tiptap/react';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import React from 'react';

import styles from './RichText.module.css';

interface RichTextProps {
  content: {};
  removeTitle: boolean;
}
export const RichText: React.FC<RichTextProps> = ({
  content,
  removeTitle = false,
}) => {
  const editor: Editor | null = useEditor({
    /** @ts-expect-error - unknown ts issue  */
    extensions: [StarterKit, TextStyle, Color, Underline, Link],
    content,
    editable: false,
  });
  return (
    <div className={`${styles.richTextContainer} pb-5`}>
      {!removeTitle && (
        <h1 className={`${styles.richTextHeader} sm:mx-0 mx-10 pb-1`}>
          Description
        </h1>
      )}

      <div className={`sm:mx-0 mx-10 pb-1`}>
        <EditorContent editor={editor} />
      </div>
    </div>
  );
};
